import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Bare / chromeless shell for the public landing & gateway pages (Course
 * Catalogue homepage and the Sign In / Login page). Unlike AppLayout it mounts
 * NO global AppNavbar and no footer, so these pages render full-bleed as a
 * standalone landing experience. Authenticated in-app pages keep AppLayout (with
 * its nav) — this layout is scoped to the public entry surface only.
 *
 * A content container is retained so Bootstrap grid rows keep their gutters;
 * pages control their own vertical rhythm.
 */
export default function BareLayout() {
  return (
    <div className="bare-layout d-flex flex-column min-vh-100">
      <main className="flex-grow-1">
        <div className="container-fluid p-0">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
